<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="stage-page-header">
            <div class="stage-page-header-row">
                <div class="stage-page-header-main">
                    <h1 class="stage-page-title">{{ $t('CMS-Sprachen') }}</h1>
                </div>
                <div class="stage-page-header-actions">
                    <router-link class="btn-stage-icon-plain" :title="$t('Back')" :aria-label="$t('Back')" to="/workspace/cms">
                        <svg-vue class="h-4 w-4" icon="font-awesome.regular.arrow-left"></svg-vue>
                    </router-link>
                    <router-link class="btn-stage-icon-plain" :title="$t('Sprache anlegen')" :aria-label="$t('Sprache anlegen')" to="/workspace/cms/languages/new">
                        <svg-vue class="h-4 w-4" icon="font-awesome.regular.plus"></svg-vue>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="stage-page-body stage-page-fill">
            <div class="w-full h-full bg-white shadow sm:rounded relative overflow-hidden flex flex-col min-h-0">
                <loading :status="loading"/>

                <div class="relative flex-1 min-h-0 overflow-hidden">
                    <div class="h-full overflow-auto">
                        <div v-if="languages.length > 0" class="hidden sm:block">
                            <div class="align-middle inline-block min-w-full border-b border-ultralight">
                                <table class="table-listview table-listview--zebra">
                                    <thead>
                                    <tr>
                                        <th class="table-listview-l-th">{{ $t('Sprache') }}</th>
                                        <th class="table-listview-l-th whitespace-nowrap w-32">{{ $t('Locale') }}</th>
                                        <th class="table-listview-l-th whitespace-nowrap w-32">{{ $t('Seiten') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white">
                                    <tr
                                        v-for="language in languages"
                                        :key="language.id"
                                        class="cursor-pointer"
                                        @click="$router.push('/workspace/cms/languages/' + language.id + '/edit')"
                                    >
                                        <td class="table-listview-l-td whitespace-nowrap">
                                            <div class="flex items-center min-w-0">
                                                <div class="mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-700">
                                                    <svg-vue class="w-8 h-8 p-1.5 text-gray-200" icon="font-awesome.regular.language"></svg-vue>
                                                </div>
                                                <div class="min-w-0">
                                                    <div class="flex items-center gap-2 min-w-0">
                                                        <div class="text-sm font-medium text-gray-900 truncate">{{ language.name }}</div>
                                                        <span :class="languageStatusMeta(language).dotClass" class="h-2 w-2 rounded-full flex-shrink-0"></span>
                                                    </div>
                                                    <div v-if="language.is_default" class="text-xs text-gray-500 mt-1">{{ $t('Basissprache · nicht löschbar') }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="table-listview-l-td whitespace-nowrap text-sm text-gray-700">{{ language.locale }}</td>
                                        <td class="table-listview-l-td whitespace-nowrap text-sm text-gray-700">{{ language.translations_count }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="!loading" class="h-full">
                            <empty-state />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {cmsActivationStatusMeta} from '@/utils/cms-status-badge';

export default {
    name: "cms-locales-list",
    data() {
        return {
            loading: true,
            languages: [],
        };
    },
    mounted() {
        this.loadLanguages();
    },
    methods: {
        languageStatusMeta(language) {
            return cmsActivationStatusMeta(this, language);
        },
        loadLanguages() {
            this.loading = true;
            axios.get('api/workspace/admin/cms/languages').then((response) => {
                this.languages = Array.isArray(response.data) ? response.data : [];
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
    },
}
</script>
